import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Box, Typography, useMediaQuery } from "@mui/material";
import AddEventDrawer from "./AddEventDrawer";
import { ConfirmationSnackbar } from "../Common/CustomSnackbar";
import axiosInstance from "../../utils/config/config";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AgendaCalendar = ({
  drawerState,
  selectedRange,
  userId,
  setSelectedEvent,
}) => {
  const navigate = useNavigate();
  const [eventDrawerState, setEventDrawerState] = useState(false);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { userData } = useSelector((state) => state.user);

  const calendarRef = useRef(null); // Ref for FullCalendar
  const [paidVideoData, setPaidVideoData] = useState({});
  const [success, setSuccess] = useState(false);
  const [events, setEvents] = useState([]);

  const fetchCreatorEvents = async () => {
    try {
      const eventsResponse = await axiosInstance.get(
        `/exerciseevent/getExerciseEventsByUser?userId=${userId}`
      );

      const eventsData = eventsResponse.data.exerciseEvents.map((event) => ({
        id: event.id,
        title: event.name,
        start: event.startDateTime,
        end: event.endDate,
        extendedProps: {
          duration: event.duration,
          level: event.skillLevel,
          exercise: event.category,
          start: event.startDateTime,
          equipment: "Dumbbells",
          calories: "150 kcal",
          status: "Scheduled",
          description: event.description,
          recurrenceType: event.recurrenceType,
          recurrenceEndDaye: event.recurrenceEndDate,
          parentEventId: event.parentEventId || null,
          mediaURL: event.mediaURL,
        },
      }));

      setEvents(eventsData); // Replace the events state
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddEvent = () => {
    // setEventDrawerState(true);
    navigate("/calendar/createexerciseevents");
  };

  const showAddButton = userData?.creatorId ? true : false; // <-- Replace with your real condition

  const rightToolbar = smallScreen
    ? showAddButton
      ? "addEventButton"
      : ""
    : showAddButton
    ? "timeGridDay,timeGridWeek,dayGridMonth addEventButton"
    : "timeGridDay,timeGridWeek,dayGridMonth";

  const customButtons = showAddButton
    ? {
        addEventButton: {
          text: "Add Event",
          click: handleAddEvent,
        },
      }
    : {};

  const handleTabChange = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      if (selectedRange === "daily") {
        calendarApi.changeView("timeGridDay");
      } else if (selectedRange === "weekly") {
        calendarApi.changeView("timeGridWeek");
      } else if (selectedRange === "monthly") {
        calendarApi.changeView("dayGridMonth");
      }
    }
  };
  const renderEventContent = (eventInfo) => {
    const { duration, level, exercise, equipment, calories, status } =
      eventInfo.event.extendedProps;
    const title = eventInfo.event.title;
    return (
      <Box
        sx={{
          border: `1px solid ${status === "Scheduled" ? "red" : "#ccc"}`,
          borderRadius: "8px",
          padding: "8px",
          backgroundColor: "#fff",
          width: "100%",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 600,
            backgroundColor: "red",
            color: "white",
            width: "fit-content",
            mb: 1,
            p: 0.5,
            borderRadius: "6px",
          }}
        >
          {duration}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#000", fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#666" }}>
          {equipment}
        </Typography>
      </Box>
    );
  };

  useEffect(() => {
    handleTabChange();
    if (userId) {
      fetchCreatorEvents();
    }
  }, [selectedRange]);

  return (
    <Box sx={{ mt: 4, pb: 12 }}>
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={"Exercise Event Created Succesfully."}
      />
      {smallScreen ? (
        <FullCalendar
          ref={calendarRef}
          plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
          initialView="timeGridDay"
          headerToolbar={{
            left: "prev,next",
            center: "title",
            right: rightToolbar,
          }}
          customButtons={customButtons}
          events={events}
          eventContent={renderEventContent}
          eventClick={(e) => {
            const selectedEvent = e.event;
            navigate("/calendar/exerciseview", {
              state: {
                id: selectedEvent.id,
                title: selectedEvent.title,
                start: selectedEvent.startDateTime,
                extendedProps: selectedEvent.extendedProps,
              },
            });
          }}
          slotMinTime="00:00:00"
          slotMaxTime="24:00:00"
          slotDuration="24:00:00"
          timeZone="UTC"
          height="500px"
          allDaySlot={false}
          eventOverlap={false}
        />
      ) : (
        <>
          <FullCalendar
            plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
            initialView="timeGridDay"
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: rightToolbar,
            }}
            customButtons={customButtons}
            events={events}
            eventContent={renderEventContent}
            eventClick={(e) => {
              setSelectedEvent(e.event);
              drawerState(true);
            }}
            slotMinTime="00:00:00"
            slotMaxTime="24:00:00"
            slotDuration="24:00:00"
            timeZone="UTC"
            height="500px"
            allDaySlot={false}
            eventOverlap={false}
          />

          <AddEventDrawer
            drawerState={eventDrawerState}
            setDrawerState={setEventDrawerState}
            paidVideoData={paidVideoData}
            setSuccess={setSuccess}
            type="video"
          />
        </>
      )}
    </Box>
  );
};

export default AgendaCalendar;
